import {RelationService} from "../services/core/RelationService";
import {ConfigInterface} from "../../config";
import {ContactService} from "../services/core/ContactService";
import {ProjectService} from "../services/core/ProjectService";
import {AuditLogService} from "../services/core/AuditLogService";
import {EmployeeService} from "../services/core/EmployeeService";
import {QuoteService} from "../services/crm/QuoteService";
import {FinanceService} from "../services/crm/FinanceService";
import {OrderService} from "../services/crm/OrderService";
import {ProjectFileTemplateService} from "../services/crm/ProjectFileTemplateService";
import {SupplierService} from "../services/crm/SupplierService";
import {VcaPlanService} from "../services/crm/VcaPlanService";
import {EmployeeLocationService} from "../services/core/EmployeeLocationService";
import {VehicleService} from "../services/core/VehicleService";
import {ProjectTypeService} from "../services/crm/ProjectTypeService";
import {AddressService} from "../services/core/AddressService";
import {TaskService} from "../services/planning/TaskService";
import {QuantityTypeService} from "../services/planning/QuantityTypeService";
import {TeamService} from "../services/core/TeamService";
import {TimeRegistrationService} from "../services/planning/TimeRegistrationService";
import {ProjectVisitService} from "../services/planning/ProjectVisitService";
import {NotificationLogService} from "../services/core/NotificationLogService";
import {ZipcodeZoneService} from "../services/core/ZipcodeZoneService";
import {ColorService} from "../services/core/ColorService";
import {PurchaseOrderService} from "../services/core/PurchaseOrderService";
import {TodoService} from "../services/core/TodoService";
import {WorkorderService} from "../services/core/WorkorderService";
import {QuoteRequestService} from "../services/crm/QuoteRequestService";

export const useApiService = (config: ConfigInterface, tokenResolver: () => string|null, navigate: (route: string) => void) => {
  return {
    // Core
    addressService: new AddressService(config, tokenResolver, navigate),
    auditLogService: new AuditLogService(config, tokenResolver, navigate),
    contactService: new ContactService(config, tokenResolver, navigate),
    employeeLocationService: new EmployeeLocationService(config, tokenResolver, navigate),
    employeeService: new EmployeeService(config, tokenResolver, navigate),
    projectService: new ProjectService(config, tokenResolver, navigate),
    relationService: new RelationService(config, tokenResolver, navigate),
    teamService: new TeamService(config, tokenResolver, navigate),
    vehicleService: new VehicleService(config, tokenResolver, navigate),
    notificationLogService: new NotificationLogService(config, tokenResolver, navigate),
    colorService: new ColorService(config, tokenResolver, navigate),
    purchaseOrderService: new PurchaseOrderService(config, tokenResolver, navigate),
    todoService: new TodoService(config, tokenResolver, navigate),
    workorderService: new WorkorderService(config, tokenResolver, navigate),
    // CRM
    financeService: new FinanceService(config, tokenResolver, navigate),
    orderService: new OrderService(config, tokenResolver, navigate),
    projectFileTemplateService: new ProjectFileTemplateService(config, tokenResolver, navigate),
    projectTypeService: new ProjectTypeService(config, tokenResolver, navigate),
    quoteService: new QuoteService(config, tokenResolver, navigate),
    supplierService: new SupplierService(config, tokenResolver, navigate),
    vcaPlanService: new VcaPlanService(config, tokenResolver, navigate),
    quoteRequestService: new QuoteRequestService(config, tokenResolver, navigate),
    // Planning
    taskService: new TaskService(config, tokenResolver, navigate),
    quantityTypeService: new QuantityTypeService(config, tokenResolver, navigate),
    timeRegistrationService: new TimeRegistrationService(config, tokenResolver, navigate),
    projectVisitService: new ProjectVisitService(config, tokenResolver, navigate),
    zipcodeZoneService: new ZipcodeZoneService(config, tokenResolver, navigate),
  }
}